
var id = "copy2";
var markup = "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"copy2\">\n<g clip-path=\"url(#copy2_clip0_1314_186447)\">\n<path d=\"M1.5 3H8.25C8.44891 3 8.63968 3.07902 8.78033 3.21967C8.92098 3.36032 9 3.55109 9 3.75V10.5C9 10.6989 8.92098 10.8897 8.78033 11.0303C8.63968 11.171 8.44891 11.25 8.25 11.25H1.5C1.30109 11.25 1.11032 11.171 0.96967 11.0303C0.829018 10.8897 0.75 10.6989 0.75 10.5V3.75C0.75 3.55109 0.829018 3.36032 0.96967 3.21967C1.11032 3.07902 1.30109 3 1.5 3Z\" fill=\"white\" />\n<path d=\"M10.5 0.75C10.6989 0.75 10.8897 0.829018 11.0303 0.96967C11.171 1.11032 11.25 1.30109 11.25 1.5V8.25C11.25 8.44891 11.171 8.63968 11.0303 8.78033C10.8897 8.92098 10.6989 9 10.5 9H9.75V3C9.75006 2.81078 9.6786 2.62854 9.54994 2.48979C9.42128 2.35105 9.24493 2.26607 9.05625 2.25188L9 2.25H3V1.5C3 1.30109 3.07902 1.11032 3.21967 0.96967C3.36032 0.829018 3.55109 0.75 3.75 0.75H10.5Z\" fill=\"white\" />\n</g>\n<defs>\n<clipPath id=\"copy2_clip0_1314_186447\">\n<rect width=\"12\" height=\"12\" fill=\"white\" />\n</clipPath>\n</defs>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
